
<script>
	import listBase from '@_system/components/base/list.vue'
	import staffIndex from './staff/index.vue'
	export default {
		extends: listBase,
		name: 'groupIndex',
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<staff-index list={this} ref="groupstaff" row={this.currentrow} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'group',
				windowName: '分组',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			cellClick({row}) {
				
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.groupstaff.getstaff()
				})
			},
			add() {
				import('@_system/components/forms/organization/group/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'group',
						id: 0,
						controlltype: 1,
						show: true,
					}
				})

			},
			edit(row) {
				import('@_system/components/forms/organization/group/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'group',
						id: row.id,
						controlltype: 2,
						show: true,
					}
				})
			},
			adddinggroup(row){
				this.loading = true
				this.$api.group.getdinggroup({id:row.id}).then((res)=>{
					if(res==1){
						this.$confirm('钉钉群已存在，是否确认再次创建').then(()=>{
							this.createdinggroup(row)
						}).catch(()=>{
							this.loading = false
						})
					}else{
						this.createdinggroup(row)
					}				
				},()=>{
					this.loading = false
				})
			},
			updatedinggroup(row){
				this.loading = true
				this.$api.group.updatedinggroup({id:row.id,name:row.name}).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
					this.customreload()
				},()=>{
					this.loading = false
				})
			},
			createdinggroup(row){
				this.loading = true
				this.$api.group.createdinggroup({id:row.id,name:row.name}).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
					this.customreload()
				},()=>{
					this.loading = false
				})
			}

		},
		components: {
			staffIndex	
		}
	}
</script>

